import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {ChangePlanModalOpenOptions} from '@Panels/change-plan-modal-v2/change-plan-modal-v2.types';

/**
 * Opens whichever change-plan dialog the feature flag selects. Lives beside the component rather than in it so
 * that file exports only its component, which is what lets react-refresh keep its boundary.
 */
export const openChangePlanModal = (preselectLevel?: number, preselectDuration?: number, options: ChangePlanModalOpenOptions = {}): void => {
  const modalId = window.PMW.modernChangePlanDialogEnabled ? MODALS_IDS.CHANGE_PLAN_MODAL_V2 : MODALS_IDS.CHANGE_PLAN_MODAL;
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId,
      panelProps: {preselectLevel, preselectDuration, ...options},
    })
  );
};
